import { gql } from '@apollo/client';

export const SIGN_IN = gql`
  mutation SignIn($email: String!, $password: String!) {
    signIn(input: { email: $email, password: $password }) {
      status
      lockExpiresAt
      profile {
        ... on UserProfile {
          email
          id
          company {
            id
          }
          candidate {
            id
          }
        }
      }
    }
  }
`;

export const SEND_EMAIL_OTP_CODE = gql`
  mutation SendEmailOtpCode($email: String!) {
    sendEmailOtpCode(input: { email: $email }) {
      status
      usePassword
      lockExpiresAt
      errors {
        code
        message
        path
      }
    }
  }
`;

export const VERIFY_EMAIL_OTP_CODE = gql`
  mutation VerifyEmailOtpCode($email: String!, $code: String!) {
    verifyEmailOtpCode(input: { email: $email, code: $code }) {
      status
      persisted
      lockExpiresAt
      profile {
        ... on UserProfile {
          email
          id
          company {
            id
          }
          candidate {
            id
          }
        }
      }
    }
  }
`;

export const SIGN_UP = gql`
  mutation SignUp($email: String!, $name: String!, $profile: ProfileEnum!) {
    signUp(input: { email: $email, name: $name, profile: $profile }) {
      status
      profile {
        ... on UserProfile {
          email
          id
        }
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation SendResetPassword($email: String!) {
    sendResetPassword(input: { email: $email }) {
      status
    }
  }
`;

export const SIGN_OUT = gql`
  mutation SignOut {
    signOut {
      status
    }
  }
`;

export const FAST_SIGN_UP_COMPANY = gql`
  mutation FastSignUpCompany(
    $phone: String!
    $name: String!
    $email: String!
    $contact: String!
  ) {
    fastSignUpCompany(
      input: { phone: $phone, name: $name, email: $email, contact: $contact }
    ) {
      email
      status
      profile {
        ... on UserProfile {
          email
          id
        }
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const FAST_SIGN_UP_CANDIDATE = gql`
  mutation FastSignUpCandidate($input: CandidateFastSignUpInput!) {
    fastSignUpCandidate(input: $input) {
      email
      status
      profile {
        ... on UserProfile {
          email
          id
        }
      }
      errors {
        code
        message
        path
      }
    }
  }
`;
